import {faCoins, faFileLines} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import React, {useCallback, useEffect, useState, useRef} from "react"
import {LoadPanel} from 'devextreme-react/load-panel'
import DebtDataGrid from './debt-data-grid'
import {useAuth} from "../../contexts/auth"
import {getPay, getDolgSf, getTypeFinDocs, getAmountOpl} from "../../api/dogovor"
import notify from "devextreme/ui/notify"
import {verifyAccess, dogHasParameterMenu} from "../../utils/admin.utils"
import AccessDenied from "../../components/access-denied/access-denied"
import {Button} from "devextreme-react/button";
import {NumberBox, Popup, TextBox} from "devextreme-react";
import {PopupTitleWithIcon} from "../../components/popup-title-with-icon/popup-title-with-icon";
import {Buffer} from "buffer";
import {Position} from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import {Get, GetDocs} from "../../api/report";
import {SelectBox} from "devextreme-react/select-box";
import findHeaderValue from "../../utils/find-header";
import './debt.scss'
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";

import {useScreenSize} from "../../utils/media-query";
//import {Link} from "react-router-dom";
const DebtPage = () => {
    const {selectedDog, user} = useAuth()
    const [loadingDocs, setLoadingDocs] = useState(false)
    const [dataDocs, setDataDocs] = useState([])
    const [visiblePage, setVisiblePage] = useState(true)

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [amount, setAmount] = useState(0)
    const [commissionPrc, setCommissionPrc] = useState(0)
    const [amountPop, setAmountPop] = useState(0)
    const [visible, setVisible] = useState(false)
    const [visibleIframe, setVisibleIframe] = useState(false)
    const [title, setTitle] = useState('')
    const [params, setParams] = useState({})
    const [komissiaSbera, setKomissiaSbera] = useState(0)
    const [sumWithKomissia, setSumWithKomissia] = useState(0)

    const [typeFinDocs, setTypeFinDocs] = useState([])
    const [amountOpl, setAmountOpl] = useState(500)
    const dataGridRef = useRef(null);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    let { isXSmall } = useScreenSize()
    const envTat = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt';
    const envRenergy = process.env.REACT_APP_NAME_ENV === 'renergy';
    const [message, setMessage] = useState(true)

    const handleContentReady = (e) => {
        if (isInitialLoad) {
            setIsInitialLoad(false);
            e.component.selectAll();
        }
    };

    useEffect(() => {
        setCommissionPrc(0)
        const pageRoles = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt' ? [3] : [3,4];
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(false)
            return
        }
        (async function(){
            setVisiblePage(true)
            setLoadingDocs(true)
            setIsInitialLoad(true)
            setSelectedRowKeys([])
            setAmount(0)
            setAmountPop(0)
            //вытаксиваем документы по долгу
            if (selectedDog) {
                const res = await getTypeFinDocs()
                if (res.isOk) {
                    setTypeFinDocs(res.data.result)

                    const resSf = await getDolgSf(selectedDog.kodDog)
                    if (resSf.isOk) {
                        // ставим enable/disable
                        let rezult = []
                        for (let item of resSf.data){
                            let filteredDocs = res.data.result.filter(fd => {
                                // Первое условие: vid_real должно совпадать
                                const condition1 = fd.vid_real === item.vid_real;
                                // Второе условие: если props.data.vid_pl != 3, то исключаем элементы с abbr = 'Schet_plat'
                                const condition2 = !(+item.vid_pl !== 3 && fd.abbr && fd.abbr === 'Schet_plat');
                                // Третье условие: если фикс или ГП, то исключаем элементы с abbr = 'OFZ'
                                const condition3 = !((dogHasParameterMenu(selectedDog, '3') || dogHasParameterMenu(selectedDog, '2')) && fd.abbr === 'OFZ');
                                // Четвёртое условие: не сформирован акт сверки, то исключаем элементы с abbr = 'AktSv_31'
                                const condition4 = !(+item.akt_sv === 0 && fd.abbr && fd.abbr.startsWith('AktSv'));
                                return condition1 && condition2 && condition3 && condition4;
                            });
                            item.isDisabled = !(item.sum_dolg > 0 && filteredDocs.length !== 0)
                            item.isDisabledPay = !(item.sum_dolg > 0)
                            item.isDisabledDocs = !(filteredDocs.length !== 0)
                            rezult.push(item)
                        }
                        setDataDocs(rezult)
                    } else {
                        notify(resSf.message,'error',10000)
                        setDataDocs([])
                    }
                } else {
                    notify(res.message, 'error', 5000)
                }
            }
            setLoadingDocs(false)
        })()
    },[selectedDog])

    useEffect(() => {
        (async function() {
            const res = await getAmountOpl(selectedDog?.kodDog)
            if (res.isOk) {
                setAmountOpl(res.result)
            } else {
                notify(res.message, 'error', 5000)
            }
        })()
    }, [selectedDog?.kodDog])

//region Оплата



    const onSelectionChanged = useCallback(
        ({ selectedRowKeys: changedRowKeys, selectedRowsData }) => {
            setSelectedRowKeys(changedRowKeys);
            //setSelectedEmployeeNames(getEmployeeNames(selectedRowsData));
            let sum = 0
            selectedRowsData.forEach(e => {
                if (changedRowKeys.includes(e.kod_sf)){
                    // защита от ошибок округления десятичных в js
                    sum += e.sum_dolg
                    sum = sum * 100
                    sum = sum.toFixed(0)
                    sum = sum / 100
                }
            })
            setAmount(sum)
        },
        [],
    );

    /*const onSelectionChanged = async (e) => {
        e.component.refresh(true);
        const deselectRowKeys = [];

        e.selectedRowsData.forEach((item) => {
            if (item.isDisabled)
                deselectRowKeys.push(e.component.keyOf(item));
        });
        if (deselectRowKeys.length) {
            e.component.deselectRows(deselectRowKeys);
        }

        // логика снятия selectAll checkbox
        let count = dataDocs.filter(e => !e.isDisabled).length
        setPrevSelect(e.selectedRowKeys.length)
        if (e.currentDeselectedRowKeys.length === 0 && prevSelect === count){
            e.component.clearSelection();
            setSelectedRowKeys([])
            e.component.refresh(true);
            return;
        }
        // конец
        e.component.refresh(true);

        let selectArray = e.selectedRowKeys
        setSelectedRowKeys(selectArray)
        let sum = 0
        dataDocs.forEach(e => {
            if (selectArray.includes(e.kod_sf)){
                // защита от ошибок округления десятичных в js
                sum += e.sum_dolg
                sum = sum * 100
                sum = sum.toFixed(0)
                sum = sum / 100
            }
        })
        setAmount(sum)
    }*/

    const onBtnPopClick = async (amount, orderNumber, kod_sf) => {
        console.log(amount + '-' + orderNumber + '-' + commissionPrc)
        let url = window.location.href
        if (url.includes('debt')) url = url.replace(/(.*debt).*/,'$1');
        setAmountPop(amount)
        setKomissia(amount)
        const result = dataDocs
            .filter(item => kod_sf.includes(item.kod_sf) && !item.isDisabledPay)
            .map(({kod_sf, sum_dolg}) => ({kod_sf, sum_opl: sum_dolg}));
        setParams({orderNumber, location:url, kod_sf:result})
        setTitle(`Оплата`)
        setVisible(true)
    }

    const onBtnPayClick = async () => {
        let val = sumWithKomissia
        val = val * 100
        val = val.toFixed(0)

        if (val<1) {
            notify('Сумма оплаты должна быть больше нуля.', 'error', 5000)
            return
        }
        setParams(params.nameEnv = process.env.REACT_APP_NAME_ENV)
        setParams(params.amount = amountPop)
        setParams(params.sumWithKomissia = val)
        setParams(params.commission = komissiaSbera)
        setParams(params.email = user.email)
        const res = await getPay(params)

        if (res.isOk) {
            let json = res.data
            if (json.hasOwnProperty('link') || json.hasOwnProperty('formUrl')){
                const url = json.link || json.formUrl;
                window.open(url,"_self");
            } else {
                notify('Объект не содержит ссылки на оплату', 'error', 5000)
            }
        } else {
            notify(res.message, 'error', 5000)
        }
        setVisible(false)
    }

    const handleTextChange = (e) => {
        if (e.value === undefined) return
        let sumOplati = e.value? e.value:0
        setAmountPop(sumOplati)
        setKomissia(sumOplati)
    }

    const setKomissia = (sumOplati) => {
        let komissia = 0
        if (sumOplati) {
            komissia = (sumOplati/((100-commissionPrc)/100)-sumOplati).toFixed(2)
        }
        setSumWithKomissia((+sumOplati + +komissia).toFixed(2))
        setKomissiaSbera(+komissia)
    }

    const keyDown = (e) => {
        const { event } = e;
        const str = event.key;
        if (str==='.' || e.event.keyCode === 190) {
            e.event.target.value = e.event.target.value + ','
        }
    };

    /*function handler(event) {
        //alert("Файл квитанции по извещению №### еще не загрузился. Если вы перезагрузите страницу, то загрузка будет остановлена. Вы уверены, что хотите перезагрузить страницу?")
        event.preventDefault();
        return true;
    }*/

    const getIzv = useCallback(async (e,data) => {
        //setLoading(true)
        notify(`Начато формирование файла. Не обновляйте и не закрывайте браузер.`, 'success', 5000);
        try {
            let {kod_sf} = data
            let name = e.abbr
            const res = await Get(name, kod_sf)
            if (res.isOk) {
                let filename = findHeaderValue(res.data.headers, 'Content-Disposition', 'FileName')
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(res.data.data), filename)
                notify(`Файл ${filename} загружен.`, 'success', 5000);
            } else {
                notify(res.message, 'error', 4000);
            }
        } catch (e) {
            notify(e.message, 'error', 4000);
        } finally {
            //setLoading(false)
        }
    }, []);

    const showIframe = async (e, data) => {
        let {kod_sf} = data
        let name = e.abbr
        let url = window.location.origin
        if (url.includes('localhost')) url = 'http://localhost:3100'
        let src = `${url}/api/report/show?name=${name}&id=${kod_sf}`;
        if (isXSmall) {
            window.open(src, '_blank');
            return
        }
        setVisibleIframe(true)
        await new Promise((resolve) => setTimeout(resolve, 100))
        let divContainerIframe = document.getElementById('divContainerIframe')
        // Создаем элементы
        const loaderWrapper = document.createElement('div');
        loaderWrapper.style.position = 'absolute';
        loaderWrapper.style.top = '0';
        loaderWrapper.style.left = '0';
        loaderWrapper.style.width = '100%';
        loaderWrapper.style.height = '100%';
        loaderWrapper.style.display = 'flex';
        loaderWrapper.style.flexDirection = 'column';
        loaderWrapper.style.justifyContent = 'center';
        loaderWrapper.style.alignItems = 'center';
        loaderWrapper.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
        loaderWrapper.style.zIndex = '1000';

        const loaderGif = document.createElement('img');
        loaderGif.src = '/Loading_icon.webp'; // пример гифки
        loaderGif.style.width = '200px';
        //loaderGif.style.height = '50px';

        const loaderText = document.createElement('div');
        loaderText.textContent = 'Идет формирование документа...';
        loaderText.style.marginTop = '10px';
        loaderText.style.fontSize = '14px';
        loaderText.style.color = '#333';

        // Добавляем элементы в обертку
        loaderWrapper.appendChild(loaderGif);
        loaderWrapper.appendChild(loaderText);

        // Вставляем в контейнер iframe
        let f = document.createElement('iframe');
        f.src = src;

        f.className = 'iframe-findocs'
        divContainerIframe.append(f);
        divContainerIframe.appendChild(loaderWrapper);
        f.onload = function() {
            loaderWrapper.style.display = 'none';
            divContainerIframe.removeChild(loaderWrapper)
        };
        f.onerror = function() {
            loaderWrapper.style.display = 'none';
            divContainerIframe.removeChild(loaderWrapper)
            console.error('Ошибка загрузки');
        };
    }

    const closeIframe = async () => {
        let divContainerIframe = document.getElementById('divContainerIframe')
        if (divContainerIframe.getElementsByTagName('iframe')[0]) {
            divContainerIframe?.removeChild(divContainerIframe.getElementsByTagName('iframe')[0]);
        }
        setVisibleIframe(false)
    }
    //endregion оплата

    const downloadSelect = async () => {
        //setLoading(true)
        try {
            const result = dataDocs
                .filter(item => selectedRowKeys.includes(item.kod_sf) && !item.isDisabledDocs)
                .map(({kod_sf}) => (kod_sf));
            if (result.length === 0){
                notify(`У выбранных записей отсутствуют документы для скачивания.`, 'error', 5000);
                return
            }
            notify(`Начато формирование файла. Не обновляйте и не закрывайте браузер.`, 'success', 5000);
            const res = await GetDocs(result)
            if (res.isOk) {
                let filename = findHeaderValue(res.data.headers, 'Content-Disposition', 'FileName')
                let fileDownload = require('js-file-download')
                fileDownload(Buffer.from(res.data.data), filename)
                notify(`Файл ${filename} загружен.`, 'success', 5000);
            } else {
                notify(res.message, 'error', 4000);
            }
        } catch (e) {
            notify(e.message, 'error', 4000);
        } finally {
            //setLoading(false)
        }
    }

    const calcFilteredDocs = (props) => {
        let filteredDocs = typeFinDocs.filter(e => {
            // Первое условие: vid_real должно совпадать
            const condition1 = e.vid_real === props.data.vid_real;
            // Второе условие: если props.data.vid_pl != 3, то исключаем элементы с abbr = 'Schet_plat'
            const condition2 = !(+props.data.vid_pl !== 3 && e.abbr === 'Schet_plat');
            // Третье условие: если фикс или ГП, то исключаем элементы с abbr = 'OFZ'
            const condition3 = !((dogHasParameterMenu(selectedDog, '3') || dogHasParameterMenu(selectedDog, '2')) && e.abbr === 'OFZ');
            // Четвёртое условие: не сформирован акт сверки, то исключаем элементы с abbr = 'AktSv_31'
            const condition4 = !(+props.data.akt_sv === 0 && e.abbr && e.abbr.startsWith('AktSv'));
            return condition1 && condition2 && condition3 && condition4;
        });

        return filteredDocs.length > 0
            ? [...filteredDocs,{"id":"100","name":"Скачать все","sort":"1","abbr":"All"}]
            : [];
    }

    const statusEditorRender = (props) => {
        const filteredDocs = calcFilteredDocs(props)
        return (
            <>{filteredDocs.length !== 0 ?
                    <SelectBox
                        className={'disabled-select-normal-opacity'}
                        dataSource={filteredDocs}
                        disabled={filteredDocs.length === 0}
                        value={props.value}
                        valueExpr="id"
                        displayExpr="name"
                        fieldRender={() => fieldRender(props.value)}
                        itemRender={(e) => itemRender(e, props.data)}
                        dropDownOptions={{
                            resizeEnabled: true, minWidth: '239px'
                        }}
                    />
                    : <>Отсутствуют</>
            }</>
        );
    };

    const itemRender = (item, data) => {
        return (
            <div className="button-in-dropdown" onClick={(e) => {
                e.stopPropagation();
                return false;
            }}>
                <div title="Нажмите на кнопку справа" className="item-name">
                    {item.name}
                </div>
                <div className="buttons-container">
                    <div className="buttons-download">
                        {item.abbr !== 'All' && (
                            <Button
                                hint="Открыть документ"
                                icon="eyeopen"
                                title="Открыть документ"
                                onClick={() => showIframe(item, data)}
                            />
                        )}
                        <Button
                            hint="Скачать документ"
                            icon="download"
                            onClick={() => getIzv(item, data)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    const fieldRender = () => {
        //const selected = statuses.find(s => s.id === value);
        return <TextBox disabled={true}
            defaultValue='Выберите'/>;//<span>{selected?.name || 'Выберите статус'}</span>;
    };


    return (
        <>{visiblePage ?
        <div className={'content-block dx-card responsive-paddings my-debt'}>
            {/*{((!!selectedDog?.terminal && !!amountOpl && ['tatenergosbyt'].includes(process.env.REACT_APP_NAME_ENV)) || ['renergy'].includes(process.env.REACT_APP_NAME_ENV)) && selectedDog?.roles.includes(4) &&
            <MyMessage></MyMessage>
            }*/}
               <div className="row">
                <div className="col-sm-4 mr-auto">
                    <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faCoins} />
                    <h3><strong><ZagolovokFromMenu/></strong></h3>
                </div>
                {!envRenergy &&
                <div className="col-auto mb20xs">
                    <Button text="Скачать выбранные" onClick={() => downloadSelect()}
                            disabled={selectedRowKeys.length === 0}  style={{minWidth: '200px'}}
                            className={'float-right'} icon="download" ></Button>
                </div>
                }
                   {!!selectedDog?.terminal && ['tatenergosbyt','renergy','infoenergo'].includes(process.env.REACT_APP_NAME_ENV) && selectedDog?.roles.includes(4) &&
                        <div className="col-auto mb20xs">
                            <Button text={`Оплатить ${amount.toLocaleString('ru-RU')} руб.`} visible={true}
                                        className={'float-right'}
                                        type="default"
                                        stylingMode="contained"
                                        icon={envRenergy ? "images/sber_white.svg":''}
                                        onClick={() => onBtnPopClick(amount, selectedDog?.kodDog, selectedRowKeys)}
                                />
                        </div>
                   }
            </div>
            { !!amountOpl && ['renergy'].includes(process.env.REACT_APP_NAME_ENV) && selectedDog?.roles.includes(4) &&
                <h4 className="">Оплачено через личный кабинет, но ещё не обработано: {amountOpl} руб.</h4>
            }

            {!loadingDocs ?
            <>
                { envTat && message &&
                    <div className={`alert alert-primary mt-3`} >
                    Для проведения оплаты выберите галкой документы, которые будете оплачивать
                        <button type="button" className="close" style={{lineHeight:'0.7'}} onClick={()=>{setMessage(null)}} data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                }
                <DebtDataGrid
                    dataSource={dataDocs}
                    selectedRowKeys={selectedRowKeys}
                    onSelectionChanged={onSelectionChanged}
                    onContentReady={handleContentReady}
                    docsCellRender={statusEditorRender}
                    ref={dataGridRef}
                />


                {/*<form target='_blank' ACTION="https://ecomtest.akbars.ru:9999/cgi-bin/cgi_link" method="POST">
                    {Object.entries(fields).map(([k, v]) =>
                        <input name={k} type='text' value={v}/>
                    )
                    }
                    <input name='Submit' type='submit' value="Послать запрос"/><br/>

                </form>*/}
                <Popup visible={visible}
                       hideOnOutsideClick={true}
                       showCloseButton={true}
                       onHiding={() => setVisible(false)}
                       showTitle={true}
                       title={title}
                       maxWidth={400}
                       maxHeight={'90%'}
                       height={'auto'}
                       titleRender={()=>PopupTitleWithIcon(faFileLines, title,() => setVisible(false))}
                ><Position of={'.dx-drawer-content'}  />
                    <ScrollView className="big-input" width='100%' height='100%'>
                            <div className='row big-input big-input-bold'>
                        <div className='col-12 text-center'>
                            {/*<img src='images/abb-logo.svg' height={60} className={'mb-4'}  alt='Ак Барс Банк'/>*/}
                            {process.env.REACT_APP_NAME_ENV === 'tatenergosbyt' &&
                                <div>
                                    <h5>Уважаемый клиент!</h5>
                                    <p>В связи с изменениями сертификационной политики зарубежных ресурсов сервисы АО
                                        «Татэнергосбыт» могут открываться не во всех браузерах.
                                        Рекомендуем Вам перейти на браузер, поддерживающий отечественные сертификаты,
                                        либо установить в операционную систему своего устройства <a href="https://www.gosuslugi.ru/crt" target={'_blank'} rel={'noopener noreferrer'}  className='dog-href'>
                                            <strong>сертификаты безопасности Минцифры</strong>
                                        </a></p>
                                </div>
                            }
                            <NumberBox
                                defaultValue={0}
                                value={amountPop}
                                label={'Сумма к оплате'}
                                labelMode={'static'}
                                onValueChanged={handleTextChange}
                                valueChangeEvent="keyup"
                                onKeyDown={keyDown}
                                showClearButton={true}
                                min={0}
                                format='#,##0.##'
                                useMaskBehavior={true}
                                maskChar={' '}
                            />
                        </div>
                        {/*<div className='col-12 mt-1'>

                            <NumberBox
                                disabled={true}
                                defaultValue={0}
                                value={komissiaSbera}
                                label={'Комиссия'}
                                labelMode={'floating'}
                                min={0}
                                format='#0.##'
                            />
                        </div>*/}
                        <div className='col-12 mt-4'>
                            <Button className={'btn-block'} id="button"
                                    text={`Оплатить ${(+sumWithKomissia).toLocaleString('ru-RU')} руб.`}
                                    type="default"
                                    icon={envRenergy ? "images/sber_white.svg":''}
                                    stylingMode="contained"
                                    onClick={onBtnPayClick}
                            />
                        </div>
                    </div>
                    </ScrollView>
                </Popup>
                <Popup visible={visibleIframe}
                       hideOnOutsideClick={true}
                       showCloseButton={true}
                       onHiding={closeIframe}
                       showTitle={true}
                       maxWidth={1200}
                       maxHeight={'90%'}
                       height={'auto'}
                       titleRender={()=>PopupTitleWithIcon(faFileLines, "Просмотр документа",closeIframe)}
                >
                    <div id="divContainerIframe" className='findocs'></div>
                </Popup>
            </>
                :
                <LoadPanel visible={true} />
            }
        </div>
        : <AccessDenied/>}</>
    )
}

/*const MyMessage = () => {
    const [css, setCss] = useState('')
    const {syncUserData} = useAuth()
    const refreshData = useCallback(async () => {
        const res = await syncUserData();
        // возвращается только положительный результат
        if (res.isOk) {
            notify(res.message, 'success', 5000);
            return true;
        }
        return false;
    }, [syncUserData])

    return (
        <div className={`alert alert-primary alert-dismissible ${css}`} role="alert">
            <h4 className="alert-heading">Уважаемый пользователь!</h4>
            Оплата поступает на лицевой счёт в течение 4 рабочих дней.
            Для актуализации данных по платежам нажмите "<a href="/" onClick={(e) => {refreshData(); e.preventDefault();}} style={{textDecorationStyle:"dashed"}}><strong>Обновить данные</strong></a>".
            <button type="button" className="close" onClick={()=>{setCss('displayNone')}} data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    )
}*/



export default DebtPage

